export const PRODUCTS = "PRODUCTS";
export const POS_PRODUCT = "POS_PRODUCT";
export const SINGLE_PRODUCT = "SINGLE_PRODUCT";
export const GLOBAL_SEARCH_PRODUCTS = "GLOBAL_SEARCH_PRODUCTS";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const PRODUCT_DETAILS = "PRODUCT_DETAILS";
export const ADD_PRODUCT_ERROR = "ADD_PRODUCT_ERROR";